<div *ngIf="loading$ | async" class="loading-indicator">
	<mat-spinner diameter="50"></mat-spinner>
</div>